export function trackEvent(eventName) {
  if (typeof window === 'undefined') return;
  if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName });
  window.dispatchEvent(new CustomEvent('bbabdt:analytics', { detail: eventName }));
}

